import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import ModalViewOriginalRow from './ModalViewOriginalRow';

export default compose(
  withCitiesAndStreets
)(ModalViewOriginalRow);